import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.info.surface};
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;

  &:hover {
    cursor: pointer;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const CaretContainer = styled.div`
  transition: all 0.3s ease-in-out;

  ${props =>
    !props.collapsed &&
    css`
      transform: rotate(180deg);
      margin-bottom: ${props => props.theme.spacing.sp8};
    `}
`

export const MessageContainer = styled.div`
  max-height: ${props => (props.collapsed ? '0px' : props.height + 'px')};
  overflow: hidden;
  visibility: ${props => (props.collapsed ? 'hidden' : 'visible')};
  transition: all 0.3s ease-in-out;
`
